var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',[_vm._v("Roll Formula")]),_c('ul',{attrs:{"id":"log"}},_vm._l((_vm.textOutput),function(roll){return _c('li',{key:roll.id},[_vm._v("\n            "+_vm._s(roll)+"\n        ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }